import Section from "./Section";
import { useRef, useState } from "react";
import structure from "../utils/structure";
import { useDispatch } from "react-redux";
import { showRoof, hideRoof } from "../redux/roomSlice";

export default function Controls() {

    var controls = useRef(null);
    var sectionHeader = useRef(null);
    var [currentStep, setCurrentStep] = useState(1);
    var [currentStepName, setCurrentStepName] = useState(structure[0].title);
    const dispatch = useDispatch();

    function sectionHover(number, text) {
        sectionHeader.current.innerHTML = "<strong>" + number + "</strong> " + text;
    }

    function sectionLeave() {
        sectionHeader.current.innerHTML = "<strong>" + currentStep + "</strong> " + currentStepName;
    }

    function sectionClick(number, text) {
        setCurrentStep(number);
        setCurrentStepName(text);
        sectionHeader.current.innerHTML = "<strong>" + number + "</strong> " + text;
        var buttons = document.querySelector("#steps").querySelectorAll("button");
        var sections = document.querySelector("#controls-content").children;
        for (let i = 0; i < buttons.length; i++) {
            if (Number(buttons[i].id) == number) {
                buttons[i].classList.add("selected");
                sections[i].classList.remove("hidden");
            } 
            else {
                buttons[i].classList.remove("selected");
                sections[i].classList.add("hidden");
            }
        }
        if (number == 2) { dispatch(showRoof()); }
        if (number == 4) { dispatch(hideRoof()); }
    }

    return (
        <div id="controls">
            <div id="steps">
                <div id="steps-header" ref={sectionHeader}>
                    <strong>1</strong> Modelos de vivienda
                </div>
                {structure.map((child, key) => {
                    return (
                        <button
                            id={key + 1}
                            key={key + 1}
                            name={child.title}
                            className={key == 0 ? "selected" : ""}
                            onMouseEnter={() => sectionHover(key + 1, child.title)}
                            onMouseOut={sectionLeave}
                            onClick={() => sectionClick(key + 1, child.title)}
                        />
                    );
                })}
            </div>
            <div id="controls-content" ref={controls}>
                {structure.map((child, key) => {
                    return (
                        <Section
                            id={key + 1}
                            key={key + 1}
                            title={child.title}
                            element={child}
                            className={key == 0 ? "" : " hidden"}
                            multi={child.multiSelect}
                        />
                    );
                })}
                <div id="disclaimer">
                    {(currentStep == 2 || currentStep == 3|| currentStep == 4) && <p>{structure[currentStep - 1].disclaimer}</p>}
                    <img src="/images/europa.png" alt="Financiado por la Unión Europea" className="funding-logo"/>
                    <img src="/images/cdti.png" alt="Ministerio de Ciencia, Innovación y Universidades" className="funding-logo"/>
                    <img src="/images/recuperacion.png" alt="Plan de Recuperación, Transformación y Resilencia" className="funding-logo"/>
                </div>
            </div>
        </div>
    );
}
